// import { useState, useRef } from "react";
import PropTypes from "prop-types";

import { UserProfile } from "@/Components/DocumentModal/DocumentSideBar/DocumentModalSideBar";
import { calculateAge, formatCalendarDate } from "@/Utils/helper";
import mixColorWithWhite from "@/Components/TreatmentPage/utils/helperFn";

import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import "./BottomContentSideBar.css";
import ButtonLoader from "../../Loaders/ButtonLoader";

import BottomContentSideBar from "./BottomContentSideBar";
import DocumentRenameComponentAssemble from "./rename-assemble-doc";

function PageInfo({ page, documentSlot, panel, file_name }) {
  const { page_icon = "", name = "" } = page || {};
  if (
    Object.keys(page || {}).length === 0 &&
    (documentSlot === null || documentSlot === undefined) &&
    panel === null
  ) {
    return null;
  }
  return (
    <div
      className="d-flex flex-column"
      style={{
        minHeight: "21px",
        maxHeight: "63px",
        fontWeight: "600",
      }}
    >
      <div
        className="text-bold p-l-5 d-flex align-items-center"
        style={{
          height: "21px",
          fontWeight: "600",
          gap: "5px",
        }}
      >
        <span className="">
          {page_icon && (
            <img
              src={page_icon}
              className="ic ic-15 d-flex align-items-center justify-content-center"
              alt=""
              style={{
                width: "15px",
                height: "15px",
              }}
            />
          )}
        </span>
        {name} Page {documentSlot === null || documentSlot?.slot_number === 0 ? "Generally" : ""}
      </div>

      {documentSlot !== null &&
        documentSlot?.slot_number !== 0 &&
        documentSlot?.page?.name === "Treatment" && (
          <div
            className="text-bold"
            style={{
              fontWeight: 600,
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                width: "100%",
                gap: "5px",
                background: mixColorWithWhite(panel?.specialty?.color, 10),
              }}
            >
              <span
                style={{
                  background: panel?.specialty?.color,
                  height: "21px",
                  width: "21px",
                  minWidth: "21px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {panel?.specialty?.name[0]}
              </span>

              <span
                style={{
                  flex: 1,
                  width: "194px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {panel?.page?.panel_name}
              </span>
            </div>
          </div>
        )}

      {documentSlot?.page?.name !== "Treatment" && page?.panels && (
        <div
          className="text-bold p-l-5"
          style={{
            fontWeight: 600,
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{
              width: "100%",
              gap: "5px",
            }}
          >
            <span
              style={{
                flex: 1,
                width: "215px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {panel?.page?.panel_name}
            </span>
          </div>
        </div>
      )}

      {documentSlot !== null && documentSlot?.slot_number !== 0 && (
        <div
          className="text-bold p-l-5"
          style={{
            minHeight: "21px",
            fontWeight: 600,
            flex: 1,
            width: "215px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: !page?.panels ? "" : "nowrap",
          }}
        >
          {documentSlot?.slot_number}.{" "}
          {documentSlot?.slot_name === null ? file_name : documentSlot?.slot_name}
        </div>
      )}
    </div>
  );
}

PageInfo.propTypes = {
  page: PropTypes.shape({
    page_icon: PropTypes.string,
    name: PropTypes.string,
  }),
};

const DocumentModalSideBar = ({
  documentData,
  // pages,
  // slotsData,
  // onRefetchSlotsData,
  deletePages,
  addPageBreak,
  fileName,
  docName,
  setDocName,
  saveDocument,
  saveLoading,
  state,
  dispatch,
  selectedPages,
  addPageNumbers,
  // setFullPreview,
  fullPreview,
  createFullPreview,
  pageAdded,
  removePageNumbers,
  deleteFPPages,
}) => {
  const {
    id: docId,
    for_client: clientInfo,
    for_case: caseInfo,
    // file_name,
    // docDate,
    // attached_by: attachUser,
    document_slot: documentSlot,
  } = documentData;
  const clientId = clientInfo?.id;
  const caseId = caseInfo?.id;
  const fontSizes = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26];

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    switch (name) {
      case "textbox1":
        dispatch({ type: "SET_TEXTBOX1", payload: value });
        break;
      case "textbox2":
        dispatch({ type: "SET_TEXTBOX2", payload: value });
        break;
      case "checked":
        dispatch({ type: "SET_CHECKED", payload: checked });
        break;
      case "fontsize":
        dispatch({ type: "SET_FONTSIZE", payload: value });
        break;
      case "align":
        dispatch({ type: "SET_ALIGN", payload: value });
        break;
      default:
        break;
    }
  };

  const handleInsertPageBreak = () => {
    let resultText = "";
    if (state.checked) {
      resultText += `${fileName}\n`; // Append the file name if checkbox is checked
    }
    if (state.textbox1) {
      resultText += `${state.textbox1}\n`; // Append the file name if checkbox is checked
    }
    if (state.textbox2) {
      resultText += `${state.textbox2}\n`; // Append the file name if checkbox is checked
    }
    if (resultText.trim() !== "") {
      addPageBreak(resultText); // Only call addPageBreak if resultText is not empty
    }
  };

  return (
    <div
      className={"right-sidebar d-flex flex-column "}
      style={{
        width: "220px",
        zIndex: "1",
        minWidth: "220px",
      }}
    >
      <div className="bluish-effect" />
      <div
        className="d-flex flex-column justify-content-between h-100"
        style={{
          backgroundColor: "#f2f5f7",
        }}
      >
        <div>
          <span
            className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            CASE
          </span>
          <div
            className="client-name d-flex align-items-center side-bar-padding"
            style={{ height: "21px", background: "var(--primary-2)" }}
          >
            <UserProfile clientInfo={clientInfo} />
          </div>
          <div
            className="tile-row w-100 p-l-5 p-r-5 d-flex align-items-center justify-content-between"
            style={{ height: "21px", background: "var(--primary-4)" }}
          >
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              <span
                className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                style={{ marginRight: "5px" }}
              >
                <img
                  src={birthdayIcon}
                  className=""
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                />
              </span>

              <p className="text-black font-weight-semibold d-block">
                {formatCalendarDate(clientInfo?.birthday)
                  ? formatCalendarDate(clientInfo?.birthday)
                  : clientInfo?.birthday || ""}
              </p>
            </div>
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              <span
                className=" text-label  fw-bold d-flex align-items-center"
                style={{ marginRight: "5px", color: "var(--primary-25)", fontWeight: "600" }}
              >
                age
              </span>

              <p className="font-weight-semibold">{calculateAge(clientInfo?.birthday)}</p>
            </div>
          </div>
          <div
            className="tile-row w-100 p-l-5 p-r-5 d-flex flex-column align-items-start"
            style={{ height: "42px", background: "var(--primary-2)" }}
          >
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              {caseInfo?.case_type?.casetype_icon && (
                <span
                  className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                  style={{ marginRight: "5px" }}
                >
                  <img
                    style={{
                      width: "15px",
                      height: "15px",
                    }}
                    src={caseInfo?.case_type?.casetype_icon}
                    alt="icon"
                  />
                </span>
              )}

              <p className="text-black font-weight-semibold d-block">
                {caseInfo?.case_type?.name || "N/A"}
              </p>
            </div>
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              <span
                className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                style={{ marginRight: "5px" }}
              >
                <img
                  src={incidentIcon}
                  className=""
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                />
              </span>

              <p className="font-weight-semibold">
                {formatCalendarDate(caseInfo?.incident_date) || "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div>
          <span
            className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            DOCUMENT NAME
          </span>

          <DocumentRenameComponentAssemble
            initialDocumentName={documentData?.file_name}
            docId={docId}
          />
        </div>

        <div className="basic-info m-r-0 m-l-0">
          {/* Basic info content */}

          {/* Other basic info fields */}
          <span
            className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            LOCATION
          </span>
          <div
            className="d-flex align-items-center justify-content-between m-b-0"
            style={{
              background: "white",
              minHeight: "21px",
              maxHeight: "63px",
            }}
          >
            <div
              className="tile-row d-flex align-items-center justify-content-start flex-wrap w-100 align-items-center"
              style={{
                minHeight: "21px",
                maxHeight: "63px",
                overflow: "hidden",
                overflowWrap: "break-word", // ensures wrapping inside
                whiteSpace: "normal", // allows wrapping of long words
              }}
            >
              <PageInfo
                page={documentSlot?.page || {}}
                documentSlot={documentSlot}
                panel={documentSlot}
                file_name={documentData?.file_name}
              />
            </div>
          </div>
        </div>

        {fullPreview ? (
          <>
            <div className="side-bar-padding p-r-5">
              <div>
                <button
                  type="button"
                  className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100 mt-2"
                  onClick={deleteFPPages}
                  disabled={selectedPages.length === 0}
                >
                  Delete Pages
                </button>
              </div>

              <div>
                <input
                  type="text"
                  className="form-control col height-25 mt-2"
                  value={docName}
                  placeholder="Enter Document Name"
                  onChange={(e) => setDocName(e.target.value)}
                />
              </div>

              <div>
                <button
                  type="button"
                  className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100 mt-2"
                  onClick={saveDocument}
                  disabled={docName ? false : true}
                >
                  {saveLoading ? <ButtonLoader /> : "Save New Document"}
                </button>
              </div>

              {pageAdded === false ? (
                <>
                  <div>
                    <div className="form-check mt-1 p-0">
                      <label className="form-check-label mb-0">Position</label>
                      <select
                        className="form-select height-25 d-flex align-items-center p-0 p-l-5 ms-2"
                        name="align"
                        id="align"
                        value={state.align}
                        onChange={handleChange}
                      >
                        <option value="center">Center</option>
                        <option value="left">Left</option>
                        <option value="right">Right</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <button
                      type="button"
                      className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100 mt-1"
                      onClick={addPageNumbers}
                    >
                      Add Page Numbers
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <button
                      type="button"
                      className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100 mt-2"
                      onClick={removePageNumbers}
                    >
                      Remove Page Numbers
                    </button>
                  </div>
                </>
              )}
            </div>
            <div
              className="d-flex flex-column"
              style={{ gap: window.innerWidth <= 1920 ? "0px" : "70px" }}
            >
              <BottomContentSideBar
                docId={docId}
                caseId={caseId}
                clientId={clientId}
                isDisabled={true}
              />
            </div>
          </>
        ) : (
          <>
            <div className="side-bar-padding p-r-5">
              <div>
                <button
                  type="button"
                  className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100"
                  onClick={deletePages}
                  disabled={selectedPages.length === 0}
                >
                  Delete Pages
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100 mt-1"
                  onClick={handleInsertPageBreak}
                >
                  Insert Break Page
                </button>
              </div>
              <div>
                <input
                  type="text"
                  name="textbox1"
                  className="form-control col height-25 mt-2"
                  value={state.textbox1}
                  onChange={handleChange}
                />
              </div>
              <div>
                <input
                  type="text"
                  name="textbox2"
                  className="form-control col height-25 mt-2"
                  value={state.textbox2}
                  onChange={handleChange}
                />
              </div>
              <div>
                <div className="d-flex gap-1 align-items-center col mt-2">
                  <input
                    className="form-check mb-0"
                    type="checkbox"
                    style={{
                      minHeight: "13px",
                    }}
                    name="checked"
                    checked={state.checked}
                    onChange={handleChange} // Handle checkbox change
                  />
                  <label className="form-check-label mb-0">Insert File Name</label>
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center position-relative custom-select-new-provider gap-1 mt-2 p-0">
                  <label
                    className="form-check-label mb-0"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    Select Font Size
                  </label>
                  <select
                    className="form-control height-25 d-flex align-items-center p-l-5 p-0"
                    name="fontsize"
                    id="fontsize"
                    value={state.fontsize}
                    onChange={handleChange}
                  >
                    {fontSizes.map((font) => (
                      <option value={font}>{font}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <button
                  type="button"
                  className="btn btn-primary height-25 d-flex align-items-center justify-content-center w-100 mt-2"
                  onClick={createFullPreview}
                >
                  Full Preview
                </button>
              </div>
            </div>
            <div
              className="d-flex flex-column"
              style={{ gap: window.innerWidth <= 1920 ? "0px" : "70px" }}
            />
          </>
        )}
      </div>
    </div>
  );
};

DocumentModalSideBar.propTypes = {
  documentData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    for_client: PropTypes.object,
    for_case: PropTypes.shape({
      case_type: PropTypes.shape({
        name: PropTypes.string,
        casetype_icon: PropTypes.string,
      }),
      incident_date: PropTypes.string,
    }),
    file_name: PropTypes.string,
    docDate: PropTypes.string,
    attached_by: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      profile_pic_29p: PropTypes.string,
    }),
    document_slot: PropTypes.object,
  }).isRequired,
  pages: PropTypes.array.isRequired,
  slotsData: PropTypes.array.isRequired,
};

export default DocumentModalSideBar;
